import React from 'react';
import ToolbarButton from './ToolbarButton';

/**
 * 툴바용 아이콘 버튼 컴포넌트 (텍스트 없이 아이콘만)
 * @param {Object} props
 * @param {React.ReactNode} props.icon - 아이콘 컴포넌트 (Lucide React 등)
 * @param {function} props.onClick - 클릭 핸들러
 * @param {boolean} props.disabled - 비활성화 상태
 * @param {string} props.title - 툴팁 텍스트
 * @param {string} props.variant - 버튼 스타일
 * @param {string} props.className - 추가 CSS 클래스
 */
const ToolbarIconButton = ({
  icon: Icon,
  onClick,
  disabled = false,
  title = '',
  variant = 'ghost',
  className = '',
  ...props
}) => {
  return (
    <ToolbarButton
      onClick={onClick}
      disabled={disabled}
      title={title}
      variant={variant}
      className={`w-[50px] h-[50px] p-0 ${className}`} // 아이콘 버튼은 정사각형 50x50px
      {...props}
    >
      <Icon className="w-4 h-4" />
    </ToolbarButton>
  );
};

export default ToolbarIconButton;
